import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-swal-component',
  templateUrl: './swal-component.component.html',
  styleUrls: ['./swal-component.component.scss']
})
export class SwalComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    Swal.fire('Titolo', 'Descrizione', 'info');
  }

}
